import axios from 'axios';

export const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
  params: {
    regionCode: 'US',
    part: 'snippet,id',
    order: 'date',
    maxResults: 50,
  },
  headers: {
    'X-RapidAPI-Key': 'a146d8da7fmshb6b49ebd01e8937p15cabdjsn4ea302b31313',
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com',
  },
};

const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}/${url}`, options);

  return data;
};

export default fetchFromAPI;
